import React, { useEffect } from "react";
import "./App.css";
import "./index.css";
import "./components/common-components/common_css/Common_Form_Css.css";

import { Route, Routes, useNavigate } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Categories from "./components/categories/Categories";
import About_us from "./components/about_us/About_us";
import Wishlist from "./components/wishlist/Wishlist";
import Shop from "./components/shop/Shop";
import Blog from "./components/blog/Blog";
import Blog_inner from "./components/blog/blog_inner/Blog_inner";
import Contact_us from "./components/contact_us/Contact_us";
import My_Account from "./components/my_account/My_Account";
import Product_details from "./components/product_details/Product_details";
import Cart_Products from "./components/cart_Products/Cart_Products";
import Proceed_to_Checkout from "./components/proceed_to_Checkout/Proceed_to_Checkout";
import Privacy_Policy from "./components/privacy_policy/Privacy_Policy";
import Terms_Conditions from "./components/terms_conditions/Terms_Conditions";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";
import Faq from "./components/faq/Faq";
import Order_details from "./components/my_orders/order_details/Order_details";
import Cancel_order from "./components/my_orders/cancel_order/Cancel_order";
import Return_order from "./components/my_orders/cancel_order/Return_order";
import Delivered_order from "./components/my_orders/delivered_order/Delivered_order";
import Cancel_order_details from "./components/my_orders/cancel_order_details/Cancel_order_details";
import Return_order_details from "./components/my_orders/return_order_details/Return_order_details";
import { useDispatch, useSelector } from "react-redux";
import { checkTokenValidity } from "./features/auth/authSlice";
import { getAllCart, postToLoginCart } from "./features/cart/cartSlice";
import Wallet from "./components/wallet/Wallet";
import Cookies from "js-cookie";
import Product_Listing_Page_ChildCategory from "./components/product_listing_page_childCategory/Product_Listing_Page_ChildCategory";
import Diamond_Education from "./components/diamond_education/Diamond_Education";
import Certification from "./components/certification/Certification";
import Product_Shape from "./components/product_listing_page_childCategory/Product_Shape";
import { appSetup } from "./features/master/masterSlice";
import { myAccount } from "./features/my_account/Slice";
import { getAllWishlist } from "./features/wishlist/wishlistSlice";
import Enggagement from "./components/enggagement/Enggagement";
import Payment_Success_Modal from "./components/common-components/Payment_Success_Modal/Payment_Success_Modal";
import Payment_Failed_Modal from "./components/common-components/Payment_Failed_Modal/Payment_Failed_Modal";
function App() {
  const dispatch = useDispatch();
  const checkToken = () => {
    dispatch(checkTokenValidity());
  };

  useEffect(() => {
    checkToken();
  }, []);

  const isSignIn = useSelector((state) => state.auth.is_signin);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(appSetup());
    if (isSignIn) {
      dispatch(myAccount());
    }
    if (isSignIn) {
      dispatch(getAllWishlist());
    }
  }, [dispatch, isSignIn]);
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/product-details/:id" element={<Product_details />} />
        <Route path="/product-cart" element={<Cart_Products />} />
        <Route path="/proceed-to-Checkout" element={<Proceed_to_Checkout />} />
        <Route path="/about-us" element={<About_us />} />
        <Route path="/shops" element={<Shop />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-inner/:id" element={<Blog_inner />} />
        <Route path="/contact" element={<Contact_us />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/account" element={<My_Account />} />
        <Route path="/order-details/:id" element={<Order_details />} />
        <Route path="/cancel-order/:id" element={<Cancel_order />} />
        <Route path="/return-order/:id" element={<Return_order />} />
        <Route path="/delivered-order/:id" element={<Delivered_order />} />
        <Route
          path="/return-order-details/:id"
          element={<Return_order_details />}
        />
        <Route
          path="/cancel-order-details/:id"
          element={<Cancel_order_details />}
        />
        <Route path="/faqs" element={<Faq />} />
        <Route path="/privacy" element={<Privacy_Policy />} />
        <Route path="/terms" element={<Terms_Conditions />} />

        <Route
          path="/product-listing-child-category/:id"
          element={<Product_Listing_Page_ChildCategory />}
        />

        <Route path="/product-style" element={<Product_Shape />} />

        <Route path="/diamond-education" element={<Diamond_Education />} />

        <Route path="/certifications" element={<Certification />} />

        <Route path="/enggagement" element={<Enggagement />} />

         <Route path="/payment-success" element={<Payment_Success_Modal />} />
        <Route path="/payment-fail" element={<Payment_Failed_Modal />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
